<svg
  role="img"
  aria-hidden="true"
  focusable="false"
  viewBox="0 0 38 38"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <rect width="38" height="38" rx="8" fill="#0074C8" />
  <mask
    id="{{ uid }}-mask"
    style="mask-type: alpha"
    maskUnits="userSpaceOnUse"
    x="4"
    y="4"
    width="29"
    height="29"
  >
    <circle cx="18.5" cy="18.5" r="14.5" fill="#D9D9D9" />
  </mask>
  <g [attr.mask]="'url(#' + uid + '-mask)'">
    <path
      d="M11.094 12.6028C12.2694 11.2666 14.3054 11.1362 15.6416 12.3115C16.9778 13.4868 17.1083 15.5229 15.9329 16.8591L-10.5146 46.9267C-11.69 48.2629 -13.726 48.3933 -15.0622 47.218C-16.3984 46.0427 -16.5289 44.0066 -15.3535 42.6704L11.094 12.6028Z"
      fill="white"
    />
    <path
      d="M25.1438 10.7158C26.3192 9.3796 28.3552 9.24919 29.6914 10.4245C31.0276 11.5999 31.1581 13.6359 29.9827 14.9721L3.44802 45.1388C2.27268 46.475 0.236653 46.6055 -1.09957 45.4301C-2.43579 44.2548 -2.56621 42.2187 -1.39086 40.8825L25.1438 10.7158Z"
      fill="white"
    />
    <rect
      x="31.48"
      y="17.2644"
      width="6.44445"
      height="46.6205"
      rx="3.22222"
      transform="rotate(41.3349 31.48 17.2644)"
      fill="white"
    />
  </g>
</svg>
